import { MOBILE_MEDIA_QUERY } from '../../common/components/utils/constants';
import { CalendarGroup } from './CalendarGroup';

const SELECTORS = {
	dataInputs: '[data-rangepicker-location-search]',
};

export class CalendarSearch {
	constructor() {
		this.dataInputs = [...document.querySelectorAll(SELECTORS.dataInputs)];

		const requiredElements = [this.dataInputs];
		if (requiredElements.some((ele) => !ele)) {
			return;
		}

		this.mediaQuery = window.matchMedia(MOBILE_MEDIA_QUERY);

		this.calendarGroup = new CalendarGroup(this.dataInputs, {
			...this.getSizeOptions(),
		});

		this.bindEvents();
		this.setup();
	}

	static init() {
		// eslint-disable-next-line no-new
		new CalendarSearch();
	}

	/**
	 * Bind `this` explicitly for event listeners.
	 */
	bindEvents() {
		['onMediaQueryChange'].forEach((e) => {
			this[e] = this[e].bind(this);
		});
	}

	/**
	 * Is mobile media query met.
	 * @return {boolean}
	 */
	isMobile() {
		return this.mediaQuery.matches;
	}

	getSizeOptions() {
		return {
			numberOfColumns: this.isMobile() ? 1 : 2,
			numberOfMonths: this.isMobile() ? 1 : 2,
		};
	}

	/**
	 * When the media query changes to desktop remove all mobile classes.
	 * @param {MediaQueryListEvent} e
	 */
	onMediaQueryChange() {
		this.calendarGroup.group.forEach(({ instance }) => {
			instance.setOptions({
				...this.getSizeOptions(),
			});
		});
	}

	setup() {
		this.mediaQuery.addEventListener('change', this.onMediaQueryChange);
	}
}
